import React from "react";
import { ActionMenu } from "Components";
import { ActionItem } from "Types";
import { useDerivedPolicyOverride } from "../../hooks";
import { ActionTypes, Policy } from "../../types";

type ActionClick = (actionType: ActionTypes) => void;
type RowActionProps = {
  policy: Policy;
  onActionClick: ActionClick;
};

interface IGenerateRowActions {
  hasUnsavedRevert: boolean;
  hasUnsavedOverride: boolean;
  hasCachedOverride: boolean;
  onActionClick: ActionClick;
}

const generateRowActions = ({
  hasUnsavedRevert,
  hasUnsavedOverride,
  hasCachedOverride,
  onActionClick,
}: IGenerateRowActions): ActionItem[] => {
  const result: ActionItem[] = [];

  if (!hasUnsavedRevert)
    result.push({
      text: "Edit policy",
      type: "EDIT",
      onClick: () => onActionClick("EDIT_POLICY"),
    });

  if (hasUnsavedOverride)
    result.push({
      text: "Undo edit",
      type: "UNDO",
      onClick: () => onActionClick("UNDO_OVERRIDE"),
    });

  if (hasCachedOverride && !hasUnsavedRevert)
    result.push({
      text: "Revert override",
      type: "REVERT",
      onClick: () => onActionClick("REVERT_POLICY"),
    });

  if (hasCachedOverride && hasUnsavedRevert)
    result.push({
      text: "Undo revert",
      type: "UNDO",
      onClick: () => onActionClick("UNDO_REVERT"),
    });

  return result;
};

const RowActions = ({
  policy,
  onActionClick,
}: RowActionProps): React.JSX.Element => {
  const { hasUnsavedOverride, hasCachedOverride, hasUnsavedRevert } =
    useDerivedPolicyOverride({
      policy,
    });

  return (
    <ActionMenu
      size="small"
      items={generateRowActions({
        hasUnsavedRevert,
        hasUnsavedOverride,
        hasCachedOverride,
        onActionClick,
      })}
    />
  );
};

export default RowActions;
